<template>
  <div>
    <template v-if="isLoading">
      <ob-spinner loading-text="Loading..."></ob-spinner>
    </template>
    <template v-else>
      <task-table :TaskList.sync="TaskList" :tasksTotalCount.sync="tasksTotalCount" :IsFilter="IsFilter" :isSupervisor="isSupervisor"></task-table>
    </template>
  </div>
</template>
<script>
import TaskTable from './TaskTable.vue'
export default {
  props: ["isSupervisor","openModal","taskCount"],
  data(){
    return{
      IsFilter:false,
      TaskList: [],
      isLoading: true,
      openAddTaskPopup:false,
      tasksTotalCount:''
    }
  },
  components: {
    "task-table":TaskTable
  },
   watch:{
    EmployeeId(val) {
        if(val != null && val != '')
        {
            this.fetchData()
        }
    }
  },
  computed: {
   EmployeeId() {
    if(this.$route.query.EmployeeId){
          return this.$route.query.EmployeeId
    }
    else
      return  this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
    }
  },
  created() {
    let interval = setInterval(() => {
      if(this.EmployeeId && this.EmployeeId != '') {
        clearInterval(interval);
          this.fetchData();
      }
    }, 500);
  },
  methods:{
    fetchData(Obj) {

      var isDelete = Obj
      var  isFilterCleared = Obj != '' && Obj != null ? Obj.IsFilter : false

      let filerObject = {
        SearchKey : Obj != '' && Obj != null ? Obj.SearchKey : null,
        FromDate : Obj !='' && Obj != null ? Obj.FromDate : null,
        ToDate : Obj !='' && Obj != null ? Obj.ToDate : null,
        CreatedBy : Obj != '' && Obj != null ? Obj.CreatedBy : null,
        Status : Obj != '' && Obj != null ? Obj.Status : null
      }

      let searchAndFilter = {
        EmployeeId : this.EmployeeId,
        Filter: filerObject,
        SearchIntent: Obj != '' && Obj != null ? 1 : 0
      }

      let PageIndex = Obj != '' && Obj != null && Obj.PageIndex > 0 ? Obj.PageIndex : 0
      let PageSize = Obj != '' && Obj != null && Obj.PageSize > 0 ? Obj.PageSize : 20

      if(!isFilterCleared && searchAndFilter.SearchIntent == 0)
      {
        this.IsFilter = false
        this.isLoading = true
      }
      else if(isDelete == "delete")
      {
        this.IsFilter = false;
      }
      else {
        this.IsFilter = true
          this.$loading({});
      }
      if(this.isLoading == false){
        if(Obj == 'edit' || Obj == '' || Obj == 'taskAdded' || Obj == 'delete'){
          this.isLoading = true
        }
      }
      ajax.put(`/Task/GetTasks?pageNo=${PageIndex}&pageSize=${PageSize}`, searchAndFilter , (res) => {
        this.TaskList = res.data.TasksMetaData;
        this.tasksTotalCount = res.data.Count;
        this.$emit('update:taskCount', this.tasksTotalCount)
        this.isLoading = false,
        this.$loading({}).close();
      })
    },
  },
}
</script>
<style lang="scss" scoped>
    .tasks_empty{
        margin-top: 14%;
        text-align: center;
        width: 100%;
        height: 100%;
        vertical-align: middle;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/Task.vue